var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResourceCursiveLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1377,
    height: 528,
    viewBox: "0 0 1377 528",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M688.144 523.815C721.151 523.711 753.76 518.504 788.268 505.002C1013.93 416.748 1029.53 88.3158 1270.45 17.2546C1314.71 4.19666 1353.14 3.8017 1376.03 4.90599",
    stroke: "#2A3072",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.249023 119.541C23.1395 118.681 61.5687 118.989 105.833 129.162C346.747 184.525 362.354 440.401 588.012 509.158C622.528 519.677 655.137 523.734 688.144 523.815",
    stroke: "#2A3072",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceCursiveLine);
export default __webpack_public_path__ + "static/media/resource_cursive_line.ba532150a058b156a79a66aeff850d9b.svg";
export { ForwardRef as ReactComponent };